import { readFileSync } from "node:fs";
import { dirname, join } from "node:path";
import { fileURLToPath } from "node:url";
/**
 * Read at runtime, not baked in: CI stamps the real version onto package.json
 * when it publishes. Walking up covers both `dist/index.js` (installed) and
 * `src/lib/version.ts` (`pnpm dev`).
 */
export function readVersion(): string {
  let directory = dirname(fileURLToPath(import.meta.url));

  for (let depth = 0; depth < 5; depth += 1) {
    try {
      const manifest: unknown = JSON.parse(
        readFileSync(join(directory, "package.json"), "utf8"),
      );
      const version = (manifest as { version?: unknown }).version;
      if (typeof version === "string" && version.length > 0) {
        return version;
      }
    } catch {
      // Keep walking: not every ancestor holds a manifest.
    }
    const parent = dirname(directory);
    if (parent === directory) {
      break;
    }
    directory = parent;
  }

  return "unknown";
}
